/** CoStar.Api.SuiteDetail.OwnerLeasingBrokerContactsByArea.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["BrokerNameAsc"] = 1] = "BrokerNameAsc";
    SortType[SortType["BrokerNameDesc"] = 2] = "BrokerNameDesc";
    SortType[SortType["LeaseListingsAsc"] = 3] = "LeaseListingsAsc";
    SortType[SortType["LeaseListingsDesc"] = 4] = "LeaseListingsDesc";
    SortType[SortType["LeaseListingsSFAsc"] = 5] = "LeaseListingsSFAsc";
    SortType[SortType["LeaseListingsSFDesc"] = 6] = "LeaseListingsSFDesc";
    SortType[SortType["JobTitleAsc"] = 7] = "JobTitleAsc";
    SortType[SortType["JobTitleDesc"] = 8] = "JobTitleDesc";
    SortType[SortType["LastNameAsc"] = 9] = "LastNameAsc";
    SortType[SortType["LastNameDesc"] = 10] = "LastNameDesc";
})(SortType || (SortType = {}));
